module.exports = __webpack_public_path__ + "static/img/hero_iphone_airpod_right.d9ed99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/imgs/hero_iphone_airpod_right.png
// module id = XEYB
// module chunks = 0